import { format, parseISO } from "date-fns";

export const formatMapPlotRequestDateTime = (
  value: string | null | undefined,
  emptyValue = "-"
): string => {
  if (!value) {
    return emptyValue;
  }

  try {
    const date = parseISO(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return format(date, "yyyy/MM/dd HH:mm");
  } catch {
    return value;
  }
};
